import { ADD_DOWNLOAD,SET_DOWNLOAD_COUNT,SET_SHOW_DOWNLOAD,ADD_CANCEL_DOWNLOAD,REMOVE_DOWNLOAD,UPDATE_DOWNLOAD ,REMOVE_CANCEL_DOWNLOAD,SHOW_CANCEL_POPUP, ADD_RETRY_DOWNLOAD, REMOVE_RETRY_DOWNLOAD,REFRESH_DOWNLOAD} from "../types/downloadBar";
import { DownloadItem } from "../../features/reports/types/types";

export const addDownload = (download: DownloadItem) => ({
  type: ADD_DOWNLOAD,
  payload: download,
});

export const setDownloadCount = (count: number) => ({
  type: SET_DOWNLOAD_COUNT,
  payload: count,
});

export const setShowDownload = (show: boolean) => ({
  type: SET_SHOW_DOWNLOAD,
  payload: show,
});

export const addCancelDownload = (id: string) => ({
  type: ADD_CANCEL_DOWNLOAD,
  payload: id,
});
export const removeDownload=(id:string)=>({
    type:REMOVE_DOWNLOAD,
    payload:id,
})
export const updateDownload=(id:string,statusList:string[],records:number)=>({
    type:UPDATE_DOWNLOAD,
    payload:{
        id,
        statusList,
        records,
    }
})
export const removeCancelDownload=(id:string)=>({
    type:REMOVE_CANCEL_DOWNLOAD,
    payload:id
})
export const showCancelPopup=(show:boolean)=>({
    type:SHOW_CANCEL_POPUP,
    payload:show,
})
export const addRetryDownload=(id:string)=>({
    type:ADD_RETRY_DOWNLOAD,
    payload:id,
})
export const removeRetryDownload=(id:string)=>({
    type:REMOVE_RETRY_DOWNLOAD,
    payload:id,
})
export const refreshDownload=()=>({
  type:REFRESH_DOWNLOAD,
})

